import {ConditionsManager} from '@/shared/components/conditions/models/conditionsManager';
import {ConditionPickerOption} from '@/shared/components/conditions/models/conditions';
import {store} from '@/store';

export class RuleConditionsManager extends ConditionsManager {
	private contextualConditions: ConditionPickerOption[] = [];

	constructor() {
		super(store.getters.contactAttributes);
	}

	public get conditions(): ConditionPickerOption[] {
		const attributes = this.conditionsFromCache;

		if (this.contextualConditions) {
			attributes.push(...this.contextualConditions);
		}
		return attributes;
	}

	public setContextualConditions(contextualConditions: ConditionPickerOption[]) {
		this.contextualConditions = contextualConditions;
	}
}
